import type { EligibilityCriteria } from '@frontend/user-preferences';

export const InsuranceEligibilityCalloutFeatureIds = {
  calendar: 'schedule-insurance-eligibility-calendar-callout',
  pulse: 'schedule-insurance-eligibility-pulse-callout',
} as const;

// Show the callout for up to 90 distinct display-days. Any explicit dismiss
// (X, "Maybe Later", CTA, or visiting the eligibility list) permanently hides
// it via `disableEligibility()`, which short-circuits this criteria.
export const InsuranceEligibilityCalloutDefaultCriteria: EligibilityCriteria = {
  type: 'days-shown',
  maxDaysToShow: 30,
};

export const InsuranceEligibilityCalloutTrackingIds = {
  scheduleCalendarInsuranceEligibilityCalloutDismiss: 'schedule:insurance-eligibility:callout-dismiss',
  scheduleCalendarInsuranceEligibilityCalloutOpen: 'schedule:insurance-eligibility:callout-open',
  schedulePulseInsuranceEligibilityCalloutDismiss: 'schedule-pulse:insurance-eligibility:callout-dismiss',
  schedulePulseInsuranceEligibilityCalloutOpen: 'schedule-pulse:insurance-eligibility:callout-open',
} as const;
